import { IconButton as IconButtonMui, styled } from '@mui/material';

export const IconButton = styled(IconButtonMui)`
  border: 1px solid ${({ theme }) => theme.palette.neutral[200]};
  width: 34px;
  height: 34px;
  margin-top: 16px;

  svg {
    fill: ${({ theme }) => theme.palette.neutral[400]};
  }
`;
